export enum ModalIds {
  linkToUnitModal = 'linkToUnitModal',
  permitModal = 'permitModal',
  customRequirementModal = 'permitRequirementModal',
  roleModal = 'roleModal',
  unitModal = 'unitModal',
  userModal = 'userModal',
  userRolesModal = 'userRolesModal'
}
